module.exports = new __parcel__URL__("shop_machines_stardust_miner_v2.4f577c92.png").toString();